import { render, staticRenderFns } from "./WhatsAppMessageTemplateBody.vue?vue&type=template&id=c253e324&scoped=true&"
import script from "./WhatsAppMessageTemplateBody.vue?vue&type=script&lang=js&"
export * from "./WhatsAppMessageTemplateBody.vue?vue&type=script&lang=js&"
import style0 from "./WhatsAppMessageTemplateBody.vue?vue&type=style&index=0&id=c253e324&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c253e324",
  null
  
)

export default component.exports